export default {

    state: {
      tipoCreditoAssunto: null,
      msgTipoCreditoAssunto: null
    },
  
    mutations: {
        setTipoCreditoAssunto(state, payload) {
          state.tipoCreditoAssunto = payload;
        },
        setMsgTipoCreditoAssunto(state, payload) {
          state.msgTipoCreditoAssunto = payload;
        }
    },
  
    getters: {
      getTipoCreditoAssunto(state) {
          return state.tipoCreditoAssunto;
      },
      getMsgTipoCreditoAssunto(state) {
        return state.msgTipoCreditoAssunto;
    }
    },

    actions: {
        setTipoCreditoAssunto({commit}, tipoCreditoAssunto){
          commit('setTipoCreditoAssunto', tipoCreditoAssunto);
        },
        setMsgTipoCreditoAssunto({commit}, msgTipoCreditoAssunto){
          commit('setMsgTipoCreditoAssunto', msgTipoCreditoAssunto);
        },
    },
    
  }